import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Button } from '../../button/esm';
import { transformSize } from './helpers/transformSize.js';

var defaultColors = {"primary":"icon-button__primary_19yud","secondary":"icon-button__secondary_19yud","transparent":"icon-button__transparent_19yud","negative":"icon-button__negative_19yud","tertiary":"icon-button__tertiary_19yud","transparentBg":"icon-button__transparentBg_19yud","component":"icon-button__component_19yud","loader":"icon-button__loader_19yud"};
require('./default.css');

var styles = {"border-24":"icon-button__border-24_1e2v2","border-32":"icon-button__border-32_1e2v2","border-40":"icon-button__border-40_1e2v2","border-48":"icon-button__border-48_1e2v2","border-56":"icon-button__border-56_1e2v2","size-24":"icon-button__size-24_1e2v2","size-32":"icon-button__size-32_1e2v2","size-40":"icon-button__size-40_1e2v2","size-48":"icon-button__size-48_1e2v2","size-56":"icon-button__size-56_1e2v2","iconWrapper":"icon-button__iconWrapper_1e2v2","center":"icon-button__center_1e2v2","left":"icon-button__left_1e2v2","right":"icon-button__right_1e2v2","icon":"icon-button__icon_1e2v2"};
require('./index.css');

var invertedColors = {"primary":"icon-button__primary_1wjvm","secondary":"icon-button__secondary_1wjvm","transparent":"icon-button__transparent_1wjvm","negative":"icon-button__negative_1wjvm","tertiary":"icon-button__tertiary_1wjvm","transparentBg":"icon-button__transparentBg_1wjvm","component":"icon-button__component_1wjvm","loader":"icon-button__loader_1wjvm"};
require('./inverted.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var SIZE_TO_CLASSNAME_MAP = {
    xxs: 'size-24',
    xs: 'size-32',
    s: 'size-48',
    24: 'size-24',
    32: 'size-32',
    40: 'size-40',
    48: 'size-48',
    56: 'size-56',
};
var IconButton = forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, Icon = _a.icon, _c = _a.view, view = _c === void 0 ? 'primary' : _c, _d = _a.size, size = _d === void 0 ? 48 : _d, _e = _a.colors, colors = _e === void 0 ? 'default' : _e, _f = _a.alignIcon, alignIcon = _f === void 0 ? 'center' : _f, _g = _a.transparentBg, transparentBg = _g === void 0 ? false : _g, restProps = __rest(_a, ["className", "icon", "view", "size", "colors", "alignIcon", "transparentBg"]);
    return (React.createElement(Button, __assign({}, restProps, { ref: ref, view: 'text', className: cn('cc-icon-button', className, colorStyles[colors][view], colorStyles[colors].component, styles["border-".concat(transformSize(size))], (_b = {},
            _b[colorStyles[colors].loader] = restProps.loading,
            _b[colorStyles[colors].transparentBg] = transparentBg,
            _b)), size: 's' }),
        React.createElement("span", { className: cn(styles.iconWrapper, styles[SIZE_TO_CLASSNAME_MAP[size]], styles[alignIcon]) }, React.isValidElement(Icon) ? (React.cloneElement(Icon, { className: cn(styles.icon, Icon.props.className) })) : (React.createElement(Icon, { className: styles.icon })))));
});
IconButton.displayName = 'IconButton';

export { IconButton };
